import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'trasyDef/';

export default {

    getDefinicje() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getDefinicjeWTrasie(trasa_id) {
        return axios({
            method: 'get',
            url: URL + 'trasa/' + trasa_id,
        });
    },

    getIloscPrzystankowNaTrasie(trasa_id){
        return axios({
            method: 'get',
            url: URL + 'trasa/'+trasa_id+'/ilosc',
        });
    },

    addDefinicja(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editDefinicja(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    editListaDefinicji(data){
        return axios({
            method: 'put',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    getProcedureDefinicja(id_trasy){
        return axios({
            method: 'get',
            url: URL + 'trasa/'+id_trasy+'/pPrzeliczTrasyDef',
        });
    },

    deleteDefinicja(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    pobierzPierwszyPrzystanekNaTrasie(idTr){
        return axios({
            method: 'get',
            url: URL + 'trasa/'+idTr+'/pierwszyPrzystanek',
        });
    },

    pobierzMiejscowosciNaTrasie(idTr){
        return axios({
            method: 'get',
            url: URL + 'trasa/'+idTr+'/miejscowosciNaTrasie',
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/DefinicjeService.js